export function widgetMediaUrl(value: unknown): string {
  if (value == null) return ''
  const source = String(value).trim()
  if (!source) return ''
  if (source.startsWith('/') || source.startsWith('data:image/') || source.startsWith('blob:')) return source
  try {
    const parsed = new URL(source)
    return parsed.protocol === 'http:' || parsed.protocol === 'https:' || parsed.protocol === 'blob:' ? source : ''
  } catch {
    return ''
  }
}
